// Component loader — registers all domain-specific registries on the Vue app.
//
// Replaces the monolithic global.js with organized registries under
// components/registries/. All registries are always registered (feature
// parity with global.js).
//
// Usage in application.js:
//   import { registerPageComponents } from '../lib/componentLoader.js'
//   registerPageComponents(app)
//
// All registries are imported statically because they are tiny wrappers
// around defineAsyncComponent — the actual component code still lazy-loads
// on demand. This keeps app.mount() synchronous, which is critical for
// Capybara/Selenium feature specs that expect Vue to render with the page.

import layout from '../components/registries/layout.js'
import shared from '../components/registries/shared.js'
import navigation from '../components/registries/navigation.js'
import admin from '../components/registries/admin.js'
import budget from '../components/registries/budget.js'
import charts from '../components/registries/charts.js'
import companies from '../components/registries/companies.js'
import content from '../components/registries/content.js'
import contracts from '../components/registries/contracts.js'
import dashboard from '../components/registries/dashboard.js'
import data from '../components/registries/data.js'
import market from '../components/registries/market.js'
import operations from '../components/registries/operations.js'
import portfolio from '../components/registries/portfolio.js'
import powerPlants from '../components/registries/power_plants.js'

// All domain registries
const ALL_REGISTRIES = [
  layout,
  shared,
  navigation,
  admin,
  budget,
  charts,
  companies,
  content,
  contracts,
  dashboard,
  data,
  market,
  operations,
  portfolio,
  powerPlants
]

function registerComponents(app, components) {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}

/**
 * Register all component registries on the Vue app.
 *
 * Currently registers every registry to ensure feature parity with the
 * previous global.js approach. The data-controller attribute on #app is
 * available for future per-page selective loading.
 *
 * @param {import('vue').App} app - The Vue application instance
 */
export function registerPageComponents(app) {
  for (const registry of ALL_REGISTRIES) {
    registerComponents(app, registry)
  }
}
